import { IconButton, InputAdornment, TextField, Typography } from '@material-ui/core'
import { Close, Search } from '@material-ui/icons'

interface ITextSearchProps {
    filterName :  string,
    handleChange: (e) => void,
    clearField:() => void,
    value: string,
    setValue: (value: string) => void
}

const TextSearch = ({filterName = '', handleChange, clearField, value, setValue}: ITextSearchProps) => {
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
    };
    
    const clearSeacrhField = () => {
        setValue('')
        clearField()
    }
    const onBlur = () => {
      handleChange(value);
    }
    const onkeypress = (e) => {
      if (e.key === 'Enter') {
        onBlur();
      }
    }
   return (
      <TextField
        size="small"
        variant="standard"
        value={value}
        onBlur={onBlur}
        onKeyDown={onkeypress}
        placeholder={`Filter by ${filterName}`}
        onChange={handleInputChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small"/>
            </InputAdornment>
          ),
          endAdornment: value && (
            <IconButton size="small" onClick={clearSeacrhField}>
              <Close fontSize="small" />
            </IconButton>
          ),
        }}
        style={{width: 240, height: '25%', marginTop: '2px' }}
      />
  )
}

export default TextSearch